import React from 'react';
import {DmsTab, TableView} from 'Components';

import {hashHistory} from 'react-router';
import {Form, Input, Select, Button, Row, Col, message, Table, Checkbox, Modal, Radio, Tree} from 'antd';
const Option = Select.Option;
const FormItem = Form.Item;
const Search = Input.Search;
const TreeNode = Tree.TreeNode;
import {jobList} from '../../service/job';
import {treeList,orgDetail} from '../../service/org';
import {peopleAdd,peopleDetail, peopleUpdate,fetchCustomChannelList,channelLeftSideList,saveModules} from '../../service/people';
import {checkCode,checkTel,nameValidator} from '../../utils/regexp.js';
import {showSpin,hideSpin} from 'Utils';
import {openNotice} from "../../utils";

class Regionadd extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['新建员工'],
			detail: {},
			addId:this.props.params.addId,
			count: 1,
            visible2: false,
            // 是否展示分销渠道Modal，为了不影响测试，先永久置为false
            visible: false,
            badge: 3,
            // 客戶未添加的列表
            ds1: [],
            ds2:[],
            sendDS2: [], // 保存时用到的，只存id
            selectedDS: [],
            disableRightAll: true,
            channelNames:'',
			orgindex: '',
			dataSource: [],
			searchflag: false,
			orgflag: false,
			choice: [],
			rows: [],
			total: 0,
			pageSize: 10,
			pageNo: 1,
			indexkey: '',
			sourceData: [],
			treeBig:[],
			tree: [],
			passwordFlag:true
		};
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOk2 = this.handleOk2.bind(this);
        this.handleCancel2 = this.handleCancel2.bind(this);
		this.pageChange = this.pageChange.bind(this);
		this.typeChange=this.typeChange.bind(this);
		this.checkPassword=this.checkPassword.bind(this);
		this.checkPhone=this.checkPhone.bind(this);
	}
    toRight = (e) => {
        if (this.state.ds2.length < 9) {
            this.setState({
                ds1: this.state.ds1.filter((_, i) => _.code !== e.code),
                ds2: [...this.state.ds2, e],
                sendDS2: [...this.state.sendDS2, e.code]
            });
        }
    }

    toLeft = (e) => {
        this.setState({
            ds2: this.state.ds2.filter((_, i) => _.code !== e.code),
            ds1: [...this.state.ds1, e],
            sendDS2: this.state.sendDS2.filter((_, i) => _ !== e.code)
        });
    }

    toRightAll = () => {
    }

    toLeftAll = () => {
    }


    getCustomerChannel = (param) => {
        fetchCustomChannelList(param).then(result => {
            if (result && result.code == 200) {
                this.setState({
                    modulesList: result.data
                });
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }
    componentDidMount() {
		if(this.state.addId!=0){
			this.setState({
				opts: ['编辑员工']
			})
			this.getDetail()
		}
	}
	
	getDetail() {
		peopleDetail({id: parseInt(this.state.addId, 0)}).then(result => {
			if (result.status) {
				result.data.password='******';
					let str = '';
					var data = result.data;
                    if(data.channelList!=null&&data.channelList.length>0){
                        data.channelList.forEach(x => {
                            str+=x.name+`; `
                        });
                    }
					// console.log(str)
     //            console.log(data)
					this.setState({
						detail: result.data,
                        channelNames:str
					// 	dataSource: employeeArr,
					// 	count: employeeArr.length + 1
					})
			} else {
				message.error(result.message);
			}
		})
	}
	
	//转换文本框类型
	typeChange(e){
		if(e.target.value){
			this.setState({
				type:'password'
			})
		}else{
			this.setState({
				type:'text'
			})
		}
	}

    //转换文本框类型
    channelChange(e){
			alert("hello")
    }



	passwordChange(e){
		if(e.target.value=="******"){
			this.setState({
				passwordFlag:false
			});
			const {setFieldsValue} = this.props.form;
			setFieldsValue({
				password: ''
			});
		}
	}
    handleOk = () => {
        this.setState({ visible: false });
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    // 保存自定义模块
    handleOk2 = () => {
        this.setState({visible2: false});
    }

	

	//弹出框
	handleOk = () => {
		const {rows} = this.state;
			this.setState({
				searchflag: false,
				orgflag: false
			});
		
		if (this.state.searchflag) {
			for (var j = 0; j < rows.length; j++) {
				rows[j].operation = false;
			}
		}
	}

	
	pageChange(page, pageSize) {
		this.setState({pageSize, pageNo: page});
		this.getJob(page,pageSize);
	}

	cancelHandle() {
		hashHistory.goBack();
	}
	
	submitHandle() {
		const {validateFields, getFieldsValue} = this.props.form;
		const {dataSource} = this.state;
		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			const data = {
				...getFieldsValue() //获取用户输入
			};
			var subObj={};
			subObj.name=data.name;
			if(data.sex==='1'){
				subObj.sex=1;
			}else if(data.sex==='0'){
				subObj.sex=0;
			}else{
				subObj.sex=1;
			}
			if(data.status==='1'){
				subObj.status=1;
			}else{
				subObj.status=0;
			}
			if(this.state.addId!=0){
				subObj.id=this.state.detail.id;
				subObj.account=this.state.detail.account;
				subObj.userId=this.state.detail.userId;
				if(this.state.passwordFlag){
					subObj.plainPassword='';
				}else{
					subObj.plainPassword=data.password;
				}
			}else{
				subObj.account=data.account;
				subObj.plainPassword=data.plainPassword;
			}
			
				if(data.status==='1'){
				subObj.status=1;
			}else{
				subObj.status=0;
			}
			subObj.contactInfoList=[];
			var phoneObj={};
			phoneObj.type=1;
			phoneObj.content=data.phone;
			subObj.contactInfoList.push(phoneObj);
			var telObj={};
			telObj.type=2;
			telObj.content=data.tel;
			subObj.contactInfoList.push(telObj);
			var emailObj={};
			emailObj.type=3;
			emailObj.content=data.email;
			subObj.contactInfoList.push(emailObj);
			var finallyData=[];
			if(dataSource.length>0){
				for(var d=0;d<dataSource.length;d++){
					if(dataSource[d].job!=''||dataSource[d].org!=''){
						finallyData.push(dataSource[d]);
					}
				}
			}
			subObj.employeeOrganizationList=finallyData;
      showSpin();
			if(this.state.addId!=0){
				peopleUpdate(subObj).then(result=>{
					hideSpin();
					if(result.status){
						message.success(result.message);
						hashHistory.goBack();
					}else{
						message.error(result.message);
					}
				})
			}else{
				peopleAdd(subObj).then(result=>{
					hideSpin();
					if(result.status){
						message.success(result.message);
						hashHistory.goBack();
					}else{
						message.error(result.message);
					}
				})
			}
		})
	}
	
	//password正则
	checkPassword(rule, value, callback) {
		const vaReg = /^\w{6,20}$/;
		if (value) {
			if (!(vaReg.test(value))) {
				callback('请输入6-20位的数字、字母或下划线');
			}
			callback();
		}
		callback();
	}
	
	//phone正则
	checkPhone(rule, value, callback) {
		const vaReg = /^((\+?86)|(\(\+86\)))?1\d{10}$/;
		if (value) {
			if (!(vaReg.test(value))) {
				callback('请输入正确的手机号码');
			}
			callback();
		}
		callback();
	}

    // 保存自定义模块
    handleOk2 = () => {
        this.setState({ visible2: false });
        saveModules({Itemselector: this.state.sendDS2,empId:this.state.detail.id}).then(result => {
            if (result && result.code == 200) {
                openNotice('success', '保存成功');
                this.getCustomerChannel();
                this.getDetail()
            } else {
                openNotice('error', '保存失败', (result && result.message) ? result.message : '');
            }

        });
    }

    handleCancel2 = () => {
        this.setState({ visible2: false });
    }

    openModulesDialog = () => {
        this.setState({visible2: true});
        this.getLeftSideModules();
    }

    getLeftSideModules = () => {
        channelLeftSideList().then(result => {
            if (result && result.code == 200) {
                this.setState({
                    ds1: result.data
                });
            } else {
                openNotice('error', '消息数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }




    render() {
		const {opts, detail, dataSource, total, pageNo, pageSize, rows,type, visible, badge, visible2, ds1, ds2} = this.state;

		const {getFieldDecorator} = this.props.form;
        const channelColumns = [{
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },{
            title: '渠道编码',
            dataIndex: 'code',
            key: 'code'
        },{
            title: '渠道名称',
            dataIndex: 'name',
            key: 'name'
        },{
            title: '更新时间',
            dataIndex: 'createdDate',
            key: 'createdDate',
			render:(text)=>{
         return new Date(text).format('yyyy-MM-dd hh:mm')
		}
        }];

        const itemLayout = {
            padding: '30px 0',
            textAlign: 'center',
            cursor: 'pointer'
        };
        const iconLayout = {
            fontSize: '32px'
        };
        const settingLayout = {
            float: 'right',
            fontSize: '24px',
            margin: '6px 6px 0 0',
            cursor: 'pointer'
        };
        const columns1 = [{
            title: '未选功能',
            dataIndex: 'name',
            key: 'name',
            render: text => <span>{text}</span>
        },{
            title: '操作',
            key: 'action',
            className: 'alignCenter',
            render: (text, record, index) => <Button onClick={this.toRight.bind(this, record)}>{'>'}</Button>
        }];
        const columns2 = [{
            title: '操作',
            key: 'action',
            className: 'alignCenter',
            render: (text, record, index) => <Button onClick={this.toLeft.bind(this, record)}>{'<'}</Button>
        },{
            title: '已选功能',
            dataIndex: 'name',
            key: 'name',
            render: text => <span>{text}</span>
        }];
		const loop = data => data.map((item, key) => {
			if (item.child && item.child.length) {
				return <TreeNode key={`${item.id}`} title={item.name}>{loop(item.child)}</TreeNode>;
			}
			return <TreeNode key={`${item.id}`} title={item.name}/>;
		});


		return <div className='dms-body'>
			<DmsTab options={opts} defaultKey={0}>
				<Button onClick={this.cancelHandle.bind(this)}>取消</Button>
				<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
			</DmsTab>
			<div className="dms-table-box" style={{backgroundColor: "#fff"}}>
				<Form layout="horizontal">
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="姓名" hasFeedback>
								{getFieldDecorator('name', {
									initialValue: (detail !== null && detail.name) ? detail.name : '',
									rules: [
										{
											required: true,
											message: '请输入姓名'
										},
										{
											validator: nameValidator
										}
									],
								})(<Input placeholder="请输入姓名"  readonly="true"/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="性别">
								{getFieldDecorator('sex', {
									initialValue: (detail !== null && detail.sex===0) ? '0' : '1'
								})(<Select placeholder='请选择人员性别'>
									<Option value='2'>未知</Option>
									<Option value='1'>男</Option>
									<Option value='0'>女</Option>
								</Select>)}
							</FormItem>
						</Col>
					</Row>
					
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="状态">
								{getFieldDecorator('status', {
									initialValue: (detail !== null && detail.status===0) ? '0' : '1'
								})(<Select>
									<Option value='1'>在职</Option>
									<Option value='0'>离职</Option>
								</Select>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="邮箱" hasFeedback>
								{getFieldDecorator('email', {
									initialValue: (detail !== null && detail.email) ? detail.email : '',
									rules: [
										{
											required: true,
											message: '请输入邮箱'
										},
										{
											type:'email',
											message:'请输入正确的邮箱号码'
										}
									],
								})(<Input placeholder="请输入邮箱"/>)}
							</FormItem>
						</Col>
					</Row>
					
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="手机号码" hasFeedback>
								{getFieldDecorator('phone', {
									initialValue: (detail !== null && detail.phone) ? detail.phone : '',
									rules: [
										{
											required: true,
											message: '请输入手机号码'
										},
										{
											validator: this.checkPhone
										}
									],
								})(<Input placeholder="请输入手机号码"  readonly="true"/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="座机">
								{getFieldDecorator('tel', {
									initialValue:(detail !== null && detail.tel) ? detail.tel : '',
									rules: [
										{
											validator: checkTel
										}
									],
								})(<Input placeholder="请输入座机号码"/>)}
							</FormItem>
						</Col>
					</Row>
					
					{
						this.state.addId!=0?
							<Row gutter={16}>
								<Col className="gutter-row" span={12}>
									<FormItem label="账户" hasFeedback>
										{getFieldDecorator('account', {
											initialValue: (detail !== null && detail.account) ? detail.account : '',
											rules: [
												{
													required: true,
													message: '请输入账户'
												}
											],
										})(<Input disabled placeholder="请输入登录账户"  readonly="true"/>)}
									</FormItem>
								</Col>
										<Col className="gutter-row" span={12}>
											<FormItem label="密码" hasFeedback>
												{getFieldDecorator('password', {
													initialValue: (detail !== null && detail.password) ? detail.password : '',
													rules: [
														{
															required: true,
															message: '请输入密码'
														},
														this.state.passwordFlag?
															{}
															:
														{
															validator:this.checkPassword
														}
													],
												})(<Input onFocus={this.passwordChange.bind(this)} type="password" placeholder="请输入登录密码"/>)}
											</FormItem>
										</Col>
							</Row>
							:
							<Row gutter={16}>
								<Col className="gutter-row" span={12}>
									<FormItem label="账户" hasFeedback>
										{getFieldDecorator('account', {
											initialValue: (detail !== null && detail.account) ? detail.account : '',
											rules: [
												{
													required: true,
													message: '请输入账户'
												},
												{
													validator: checkCode
												}
											],
										})(<Input placeholder="请输入登录账户" readonly="true"/>)}
									</FormItem>
								</Col>
								<Col className="gutter-row" span={12}>
									<FormItem label="密码" hasFeedback>
										{getFieldDecorator('plainPassword', {
											initialValue: (detail !== null && detail.plainPassword) ? detail.plainPassword : '',
											rules: [
												{
													required: true,
													message: '请输入密码'
												},
												{
													validator: this.checkPassword
												}
											],
										})(<Input type={type} onChange={this.typeChange} placeholder="请输入登录密码"/>)}
									</FormItem>
								</Col>
							</Row>
						}
                  {/*<Row gutter={16}>
                    <Col className="gutter-row" span={24}>
                        <FormItem label="渠道" hasFeedback>
                            {getFieldDecorator('channels', {
                                initialValue: channelNames
                            })
							( <Input type={type} onChange={this.channelChange}   placeholder=""/>)

                            }

                        </FormItem>
                    </Col>
                </Row>*/}
                    <Row gutter={16} style={{ marginTop: 16 }}>
                        <Col span={32}>
                            <div className="home-content">
                                <Button type='primary' onClick={this.openModulesDialog}
										style={{paddingLeft: 20,  cursor: 'pointer',
										height:50}}>
                               更新渠道
                                </Button>
                                <Table
                                    columns={channelColumns}
                                    pagination={false}
                                    dataSource={detail.channelList}
                                    bordered
                                    style={{padding: 20}}
                                />
                                <div onClick={this.toCredit} style={{paddingLeft: 20, paddingBottom: 10, color: '#2eabff', cursor: 'pointer'}}>
                                </div>
                            </div>
                        </Col>
                    </Row>
				</Form>
			</div>
            <Modal
                visible={visible2}
                title="请选择要添加的渠道"
                onOk={this.handleOk2}
                onCancel={this.handleCancel2}
                maskClosable={false}>
                <div>
                    <Row gutter={16}>
                        <Col span={10}>
                            <Table
								/*rowSelection={rowSelection1}
                                selectWay="onSelect"*/
                                columns={columns1}
                                dataSource={ds1}
                                pagination={false}
                                rowKey="id"
                                bordered
                            />
                        </Col>
                        <Col span={4} style={{position: 'absolute', top: '50%', left: '42%'}}>
                            <Row type="flex" justify="center">
                                <Col>
                                    <Button onClick={this.toRightAll} disabled={this.state.disableRightAll}>{'>>'}</Button>
                                </Col>
                                <Col style={{marginTop:10}}>
                                    <Button disabled={true}>{'<<'}</Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={10} style={{float: 'right'}}>
                            <Table
								/*rowSelection={rowSelection2}*/
                                columns={columns2}
                                dataSource={ds2}
                                pagination={false}
                                rowKey="id"
                                bordered
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>
		</div>
	}
}
export default Form.create()(Regionadd)


// WEBPACK FOOTER //
// ./src/routes/people/add.js